module.exports = __webpack_public_path__ + "static/media/manifest.ae3e11c0.jpg";